export default __webpack_public_path__ + "static/media/7.1e220907.svg";